// src/pages/customer/RefundPolicy.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const sections = [
  {
    title: "1. About Tripura Agro",
    body: "Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level. We are a team who understand crops, farmers, commodities and taste, committed to unparalleled quality and purity in every product we deliver.",
  },
  {
    title: "2. Eligible for Refund",
    body: "You are eligible for a full refund if you receive a damaged, defective, or incorrect product. Refund requests must be raised within 24 hours of delivery with supporting photo or video evidence.",
  },
  {
    title: "3. Non-Refundable Items",
    body: "Fresh produce, perishable goods, and items that have been consumed or partially used are not eligible for refunds. Orders cancelled after dispatch are also non-refundable.",
  },
  {
    title: "4. Refund Process",
    body: "Once your refund request is reviewed and approved, the refund will be processed within 5–7 business days. Since we operate on a Cash on Delivery model, refunds are issued via bank transfer or UPI to the details you provide.",
  },
  {
    title: "5. Processing Time",
    body: "Refund requests are reviewed within 24–48 hours of submission. You will receive a confirmation email once your refund has been approved and initiated.",
  },
  {
    title: "6. Order Cancellations",
    body: "Orders can be cancelled before they are dispatched. Once an order has been picked up for delivery, cancellations are not accepted. To cancel, contact our support team immediately after placing the order.",
  },
  {
    title: "7. How to Raise a Refund Request",
    points: [
      "Take a clear photo or video of the damaged or incorrect item.",
      "Contact us within 24 hours of receiving your order.",
      "Share your Order ID along with the evidence via email or WhatsApp.",
      "Our team will review and respond within 24–48 hours.",
      "Approved refunds are processed within 5–7 business days.",
    ],
  },
];

export default function RefundPolicy() {
  return (
    <div style={{ background: "#f7f3e3" }}>
      <Helmet>
        <title>Refund Policy | Tripura Agro</title>
        <meta
          name="description"
          content="Tripura Agro Industries was established in 2022 with the goal of leveraging supply and demand between farmers and Mandis at the national level and the final customer, who may be an individual or an institution."
        />
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">

        <h1
          className="font-bold uppercase mb-8"
          style={{
            fontSize: "clamp(1.5rem, 3vw, 2rem)",
            color: "#2d3a1e",
            letterSpacing: "0.06em",
          }}
        >
          Refund Policy
        </h1>

        <p className="text-sm sm:text-base leading-relaxed mb-10" style={{ color: "#444" }}>
          At Tripura Agro, customer satisfaction is our priority. If something isn't right with
          your order, we're here to make it right. Please read our refund policy carefully.
        </p>

        <div className="space-y-9">
          {sections.map((s) => (
            <div key={s.title}>
              <h2
                className="font-bold uppercase mb-3"
                style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
              >
                {s.title}
              </h2>

              {s.body && (
                <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
                  {s.body}
                </p>
              )}

              {s.points && (
                <ol className="space-y-2">
                  {s.points.map((p, i) => (
                    <li
                      key={i}
                      className="text-sm sm:text-base leading-relaxed pl-6 relative"
                      style={{ color: "#444" }}
                    >
                      <span
                        className="absolute left-0 font-bold"
                        style={{ color: "#4a6e30" }}
                      >
                        {i + 1}.
                      </span>
                      {p}
                    </li>
                  ))}
                </ol>
              )}
            </div>
          ))}

          {/* Contact section */}
          <div>
            <h2
              className="font-bold uppercase mb-3"
              style={{ fontSize: "1rem", color: "#2d3a1e", letterSpacing: "0.04em" }}
            >
              8. Contact Us
            </h2>
            <p className="text-sm sm:text-base leading-relaxed" style={{ color: "#444" }}>
              Need help? Contact us at:
            </p>
            <p className="text-sm sm:text-base leading-relaxed mt-2" style={{ color: "#444" }}>
              Tripura Agro Industries OPC Pvt. Ltd.<br />
              Mail Id:{" "}
              <a href="mailto:sandeep@tripuraagro.com" style={{ color: "#4a6e30", fontWeight: 600 }}>
                sandeep@tripuraagro.com
              </a>
              <br />
              Contact No.:{" "}
              <a href="tel:+919778553533" style={{ color: "#4a6e30", fontWeight: 600 }}>
                +91 9778553533
              </a>
              <br />
              1st Floor, Panigrahy Complex, Janata Lane, Digapahandi, Ganjam, Odisha
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}